/** Live MediaStreams of the call engine by source id (LiveVideo looks them up through LiveMediaContext). */
import type { LiveMedia } from "@bundle/ui";

export class StreamRegistry implements LiveMedia {
  private readonly streams = new Map<string, MediaStream>();
  private readonly listeners = new Set<() => void>();

  get = (source: string): MediaStream | undefined => this.streams.get(source);

  subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  };

  /** Shows `track` under `source` (a new MediaStream, so <video> elements pick up the change); undefined removes it. */
  set(source: string, track: MediaStreamTrack | undefined): void {
    const cur = this.streams.get(source);
    if (track === undefined) {
      if (cur === undefined) return;
      this.streams.delete(source);
    } else {
      if (cur !== undefined && cur.getTracks()[0] === track) return;
      this.streams.set(source, new MediaStream([track]));
    }
    for (const l of Array.from(this.listeners)) l();
  }

  clear(prefix: string): void {
    for (const id of this.streams.keys()) if (id.startsWith(prefix)) this.set(id, undefined);
  }
}
